// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__5N9XP","rightAdornment":"Header_rightAdornment__2t_1b"};